var provinceData = [{
	"label": "北京",
	"value": "110000"
}, {
	"label": "天津",
	"value": "120000"
}, {
	"label": "河北",
	"value": "130000"
}, {
	"label": "山西",
	"value": "140000"
}, {
	"label": "内蒙古",
	"value": "150000"
}, {
	"label": "辽宁",
	"value": "210000"
}, {
	"label": "吉林",
	"value": "220000"
}, {
	"label": "黑龙江",
	"value": "230000"
}, {
	"label": "上海",
	"value": "310000"
}, {
	"label": "江苏",
	"value": "320000"
}, {
	"label": "浙江",
	"value": "330000"
}, {
	"label": "安徽",
	"value": "340000"
}, {
	"label": "福建",
	"value": "350000"
}, {
	"label": "江西",
	"value": "360000"
}, {
	"label": "山东",
	"value": "370000"
}, {
	"label": "河南",
	"value": "410000"
}, {
	"label": "湖北",
	"value": "420000"
}, {
	"label": "湖南",
	"value": "430000"
}, {
	"label": "广东",
	"value": "440000"
}, {
	"label": "广西",
	"value": "450000"
}, {
	"label": "海南",
	"value": "460000"
}, {
	"label": "重庆",
	"value": "500000"
}, {
	"label": "四川",
	"value": "510000"
}, {
	"label": "贵州",
	"value": "520000"
}, {
	"label": "云南",
	"value": "530000"
}, {
	"label": "西藏",
	"value": "540000"
}, {
	"label": "陕西",
	"value": "610000"
}, {
	"label": "甘肃",
	"value": "620000"
}, {
	"label": "青海",
	"value": "630000"
}, {
	"label": "宁夏",
	"value": "640000"
}, {
	"label": "新疆",
	"value": "650000"
}, {
	"label": "台湾",
	"value": "710000"
}, {
	"label": "香港",
	"value": "810000"
}, {
	"label": "澳门",
	"value": "820000"
}]
export default provinceData;
